module.exports = __webpack_public_path__ + "img/logo.15e39f76.png";